import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=5bc76060&scoped=true"
import script from "./Order.vue?vue&type=script&lang=ts"
export * from "./Order.vue?vue&type=script&lang=ts"
import style0 from "./Order.vue?vue&type=style&index=0&id=5bc76060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc76060",
  null
  
)

export default component.exports